import React, { useState, useEffect } from "react";
import Api from "../Api/Api.json";
import {
	Box,
	Button,
	Card,
	CardContent,
	CardHeader,
	Paper,
	TextareaAutosize,
	Zoom,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { AddAlert, AlignVerticalCenter, Info, Send } from "@mui/icons-material";
import config from "../config/config";
import { LoadingButton } from "@mui/lab";
import QuestionAnswerOutlinedIcon from "@mui/icons-material/QuestionAnswerOutlined";
import { setLoading } from "../App";

const Support = () => {
	const [description, setDescription] = useState("");
	const [isSending, setIsSending] = useState(false);
	const [isSidebarVisible, setIsSidebarVisible] = useState(false);

	var user_id = 0;

	useEffect(() => {
		if (localStorage.getItem("upskill_user_info") !== null) {
			//navigate('/Landing/tab1')
			user_id = JSON.parse(localStorage.getItem("upskill_user_info"));
			console.log("userid");
			console.log(user_id);
		}
	});

	useEffect(() => {
		setLoading(false);
	}, []);

	const handleDescriptionChange = (e) => {
		setDescription(e.target.value);
	};

	console.log(localStorage.getItem("auth_user"));

	const getUserID = async () => {
		//call api and return script.
		const auth_user = localStorage.getItem("auth_user");
		const id_token = JSON.parse(auth_user)?.id_token;
		console.log(id_token);
		const headers = {
			Authorization: `Bearer ${id_token}`,
			"Content-Type": "application/json",
		};
		const base_url =
			"https://tib60ktrrj.execute-api.us-east-1.amazonaws.com/prod";
		const body = {
			task: "getUserInfo",
		};
		try {
			const response = await fetch(base_url, {
				method: "POST",
				headers: headers,
				body: JSON.stringify(body),
			});
			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}
			const data = await response.json();
			//setGeneratedScript(data.script);
			//setIsScriptGenerated(true);
			return data[0].id;
		} catch (err) {
			console.log(err.message);
		}
		return 0;
	};

	const handleSubmitSupportMessage = async () => {
		//call api and show message on successful submission.

		const auth_user = localStorage.getItem("auth_user");

		if (auth_user === null) {
			alert("মেসেজ পাঠানোর জন্য লগইন করুন");
			return;
		}

		//write code for counting words in generatedScript
		//console.log(generatedScript);
		const num_words = description.length;
		//console.log(topic_char_count);
		//console.log(num_words);

		if (num_words > 170) {
			alert(
				"Shorten the message (<170 words.). We'll get back to you to discuss in detail and resolve any issues."
			);
			return;
		}

		setIsSending(true);

		const user_id = await getUserID();

		if (user_id === 0) {
			alert("Something went wrong. Please try again later.");
			setIsSending(false);
			return;
		}

		console.log("user_id:", user_id);

		const base_url = Api.MUKTIBD_USER_API;

		const body = {
			task: "submitUpskillSupportMsg",
			msg: description,
			user_id: user_id,
		};

		try {
			const id_token = JSON.parse(auth_user)?.id_token;

			const headers = {
				Authorization: `Bearer ${id_token}`,
				"Content-Type": "application/json",
			};

			const response = await fetch(base_url, {
				method: "POST",
				headers: headers,
				body: JSON.stringify(body),
			});

			if (!response.ok) {
				alert(`Something went wrong. Please try again later.`);
				setIsSending(false);
				return;
			}

			const data = await response.json();

			console.log(data);

			if (data.code === 200) {
				setDescription("");
				alert(
					`Your message has been submitted. You'll receive an email(within 24 hours) responding to your request shortly.`
				);
			} else {
				alert(`Something went wrong. Please try again later.`);
			}
			//setGeneratedScript(data.script);
		} catch (err) {
			console.log(err.message);
		}
		setIsSending(false);
	};
	const [containerHeight, setContainerHeight] = useState(0);
	useEffect(() => {
		const updateHeight = () => {
			// Assuming the navbar height is 64px (adjust as needed)
			const navbarHeight = config.topbarHeight;
			const windowHeight = window.innerHeight;
			setContainerHeight(windowHeight - navbarHeight);
			// setChatAreaHeight(windowHeight - navbarHeight - 64);
		};

		updateHeight();
		window.addEventListener("resize", updateHeight);
		return () => window.removeEventListener("resize", updateHeight);
	}, []);
	return (
		<div
			className="flex items-center justify-center p-4"
			style={{ height: `${containerHeight}px` }}
		>
			<Zoom in={true}>
				<Paper className="w-full max-w-md shadow-lg p-4" elevation={3}>
					<div className="flex flex-col items-center space-y-4">
						<div className="flex items-center justify-center bg-blue-50 rounded-full w-16 h-16">
							<QuestionAnswerOutlinedIcon
								className="text-blue-600"
								style={{ fontSize: 36 }}
							/>
						</div>

						<div className="text-center">
							<h2 className="text-xl font-bold text-gray-800 mb-2">
								আপনার মন্তব্য
							</h2>
							<p className="text-sm text-gray-600 mb-4 px-2">
								এই app সম্পর্কে আপনার মন্তব্য জানান। স্বাস্থ্য
								সম্পর্কিত সমস্যার জন্য মেনু থেকে 'স্বাস্থ্য
								উপদেশ' অনুসরণ করুন অথবা 'স্বাস্থ্য উপদেশ' এর
								শেষে ডক্টরের পরামর্শ অনুরোধ করুন।
							</p>
						</div>

						<TextareaAutosize
							value={description}
							onChange={handleDescriptionChange}
							placeholder="আপনার মন্তব্য লিখুন..."
							className="w-full min-h-[120px] p-2 border border-gray-300 rounded-lg resize-y focus:outline-none focus:ring-2 focus:ring-blue-500"
						/>

						<LoadingButton
							onClick={handleSubmitSupportMessage}
							className="w-full"
							variant="contained"
							color="primary"
							endIcon={<Send />}
							loadingPosition="center"
							loading={isSending}
						>
							মেসেজ পাঠান
						</LoadingButton>
					</div>
				</Paper>
			</Zoom>
		</div>
	);
};

export default Support;
